import { Props as ReactSelectProps } from 'react-select/base';
import ReactSelect, { OptionsType } from 'react-select';
import classNames from 'classnames';

import { Label } from './Label';

import classes from './text-input.module.scss';

export interface OptionType {
  value: string;
  label: string;
}

export type Option = OptionsType<OptionType>;

const getValue = (
  options: OptionsType<OptionType>,
  inputValue?: string
): OptionType | null | undefined => {
  if (inputValue && options) {
    return options.find(({ value }) => value === inputValue) || null;
  }

  return null;
};

export const Select = ({
  className,
  label,
  required,
  inputValue,
  options,
  ...props
}: ReactSelectProps<OptionType, boolean>) => (
  <div>
    <Label>{label}</Label>
    <ReactSelect
      className={classNames(classes.input, className)}
      classNamePrefix={'react-select'}
      placeholder={'Seleziona...'}
      options={options}
      value={getValue(options as OptionsType<OptionType>, inputValue)}
      {...props}
    />
  </div>
);
